import { createFileRoute } from '@tanstack/react-router';
import { EstoqueMovimentacaoPage } from '@/features/estoque-movimentacao/page/EstoqueMovimentacaoPage';

export const Route = createFileRoute('/a/estoque/movimentacao')({
    component: EstoqueMovimentacaoPage,
});
